
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.78 4.543l-.346-.346a.668.668 0 00-.466-.187.66.66 0 00-.226 0L4.44 12.007a.665.665 0 00-.439.68v.213c0 .262.15.5.386.613l9.574 4.518 4.513 9.582a.678.678 0 00.613.387h.213c.28 0 .53-.176.626-.44l8.042-22.324a.668.668 0 00-.186-.693zm-8.827 17.833l-1.638-3.545a2.667 2.667 0 01.453-2.946l2.077-2.252a.668.668 0 000-.92l-.506-.506a.664.664 0 00-.919 0l-2.25 2.079a2.662 2.662 0 01-3.01.386l-3.54-1.639L24.172 7.81l-5.22 14.567z","fill-rule":"evenodd"}})])
          )
        }
      }
    